import { CommentsChart } from "@vericus/cadmus-common";
import { Divider, Tabs, Text } from "@vericus/cadmus-ui";

import { UserFragment } from "@/generated/graphql";

import { useThreadInsights } from "../api/use-thread-insights";
import * as styles from "./engagement-charts.css";

interface Props {
  assessmentId: string;
  workId: string;
  students: UserFragment[];
}

/**
 * Activity Report component
 *
 * This component is used to display the activity report for a given date range.
 * It displays a word count chart and a date range filter.
 *
 * This will contain 1 tabs:
 * 1. Comments and Replies - Displays a comments and replies chart
 *
 * It is used in the GroupInsightsPage components.
 */
export function EngagementCharts(props: Props) {
  const filterIds = props.students.map((s) => s.id);
  const { data } = useThreadInsights(
    props.assessmentId,
    props.workId,
    filterIds
  );

  return (
    <div className={styles.container}>
      <Tabs.Root defaultValue={"comments"}>
        <div className={styles.tabsRoot}>
          <div>
            <Tabs.List>
              <Tabs.Trigger value={"comments"}>
                Comments and Replies
              </Tabs.Trigger>
            </Tabs.List>
          </div>
        </div>
        <Divider style={{ marginBottom: 12 }} />
        <Tabs.Content value={"comments"}>
          {data && data.length > 0 ? (
            <CommentsChart
              data={data}
              list={props.students}
              xAxisKey="user_id"
            />
          ) : (
            <div className={styles.emptyContainer}>
              <Text color="grey300" kind="bodyLg" textAlign="center">
                No data available
              </Text>
            </div>
          )}
        </Tabs.Content>
      </Tabs.Root>
    </div>
  );
}
